import { Link } from "react-router-dom";
import { useShop } from "@/store";
import { M, ART } from "@/data/catalogue";
import { Reveal, MaskedLines } from "@/components/motion";

const PROC_IMGS = ["yarn", "hands", "strap", "tassel"];

export default function Artisans() {
  const { t, L } = useShop();
  const a = (k) => t(`art.${k}`);
  const entries = Object.values(ART);

  return (
    <>
      <section className="sec tight">
        <div className="wrap split">
          <div>
            <MaskedLines lines={[t("nav.artisans")]} testid="artisans-title" className="" />
            <div className="rule" style={{ margin: "22px 0" }} />
            <Reveal delay={0.3}><p className="lede">{a("h")}</p></Reveal>
          </div>
          <Reveal delay={0.15}>
            <div className="im tall"><img src={M.artisan2} alt="Wayuu artisan beside her finished bags" /></div>
          </Reveal>
        </div>
      </section>

      <section className="sec alt">
        <div className="wrap">
          <Reveal><h2 className="center" style={{ fontSize: "clamp(26px,3vw,38px)", letterSpacing: ".14em", textTransform: "uppercase" }}>{a("lk")}</h2></Reveal>
          <div className="process" style={{ marginTop: 36 }}>
            {a("steps").map((x, i) => (
              <Reveal key={i} delay={i * 0.09}>
                <div>
                  <div className="im"><img src={M[PROC_IMGS[i]]} alt={x} loading="lazy" /></div>
                  <b><i>0{i + 1}</i>{x}</b>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="sec">
        <div className="wrap">
          <Reveal><h2 className="center" style={{ fontSize: "clamp(26px,3vw,38px)", letterSpacing: ".14em", textTransform: "uppercase" }}>{a("voices")}</h2></Reveal>
          <div className="artisan-grid" style={{ marginTop: 36 }} data-testid="artisan-grid">
            {entries.map((x, i) => {
              const pic = (
                <Reveal key="p" delay={0.08}>
                  <div className="p"><img src={M[x.img]} alt={x.n} loading="lazy" /></div>
                </Reveal>
              );
              const card = (
                <Reveal key="c">
                  <div className="c" style={{ height: "100%", border: 0, background: "transparent", padding: "34px 0" }}>
                    <div className="eyebrow">{a("eb")}</div>
                    <h3>{x.n}</h3>
                    <em>“{L(x).q}”</em>
                    <p>{L(x).b}</p>
                    <div className="meta">
                      <span>{a("clan")}: {x.clan}</span>
                      <span>{a("place")}: {x.place}</span>
                      <span>{x.yrs} {a("yrs")}</span>
                    </div>
                    <Link className="btn ghost" to="/shop" style={{ alignSelf: "flex-start" }}>{t("coll.all")} →</Link>
                  </div>
                </Reveal>
              );
              return i % 2 ? [card, pic] : [pic, card];
            })}
          </div>
          <p className="notice" style={{ marginTop: 22 }}>{a("dis")}</p>
        </div>
      </section>

      <section className="sec alt">
        <div className="wrap split">
          <Reveal>
            <span className="orn" />
            <h2 style={{ marginTop: 16 }}>{a("crafted")}</h2>
            <p className="lede">{a("craftedT")}</p>
            <div style={{ marginTop: 26 }}>
              <Link className="btn" to="/shop" data-testid="artisans-shop-cta">{a("cta")}</Link>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="vid">
              <video autoPlay muted loop playsInline poster={M.artisan1}>
                <source src={M.artisan_mp4} type="video/mp4" />
              </video>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
